import {
  RecaptchaVerifier,
  type ApplicationVerifier,
  type Auth,
} from "firebase/auth";

export type PhoneOtpRecaptchaVerifierT = Readonly<{
  getRecaptchaVerifier: () => ApplicationVerifier;
  resetRecaptchaVerifier: () => void;
}>;

export type CreatePhoneOtpRecaptchaVerifierOptionsT = Readonly<{
  auth: Auth;
}>;

export function createPhoneOtpRecaptchaVerifier({
  auth,
}: CreatePhoneOtpRecaptchaVerifierOptionsT): PhoneOtpRecaptchaVerifierT {
  let verifier: RecaptchaVerifier | undefined;
  let shell: HTMLDivElement | undefined;
  let slot: HTMLDivElement | undefined;
  let badgeStyleInjected = false;

  function hideBadge(): void {
    if (badgeStyleInjected) return;

    const style = document.createElement("style");
    style.textContent = ".grecaptcha-badge { visibility: hidden !important; }";
    document.head.appendChild(style);
    badgeStyleInjected = true;
  }

  function getShell(): HTMLDivElement {
    if (shell && shell.isConnected) return shell;

    shell = document.createElement("div");
    shell.setAttribute("aria-hidden", "true");
    shell.style.position = "absolute";
    shell.style.width = "0";
    shell.style.height = "0";
    shell.style.overflow = "hidden";
    document.body.appendChild(shell);
    hideBadge();
    return shell;
  }

  function getRecaptchaVerifier(): ApplicationVerifier {
    if (verifier) return verifier;

    const parent = getShell();
    slot = document.createElement("div");
    parent.appendChild(slot);

    verifier = new RecaptchaVerifier(auth, slot, { size: "invisible" });
    return verifier;
  }

  function resetRecaptchaVerifier(): void {
    try {
      verifier?.clear();
    } finally {
      verifier = undefined;
      slot?.remove();
      slot = undefined;
    }
  }

  return {
    getRecaptchaVerifier,
    resetRecaptchaVerifier,
  };
}
